import { render, staticRenderFns } from "./CargoSearch.vue?vue&type=template&id=dfe59304&scoped=true&"
import script from "./CargoSearch.vue?vue&type=script&lang=js&"
export * from "./CargoSearch.vue?vue&type=script&lang=js&"
import style0 from "./CargoSearch.vue?vue&type=style&index=0&id=dfe59304&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe59304",
  null
  
)

export default component.exports